module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sharedObject.kind == "deleted") ? _c('div', {
    staticClass: "link deleted",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('click')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  }), _c('div', {
    staticClass: "description"
  }, [_vm._v("Cet objet a été supprimé")])]) : (_vm.sharedObject.kind == "event") ? _c('div', {
    staticClass: "link event",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('click')
      }
    }
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.sharedObject.group
    }
  }), _c('i', {
    staticClass: "fa fa-calendar-o"
  }), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("ucfirst")(_vm._f("unixtimeTo")(_vm.sharedObject.startTime, 'llll'))))]), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.sharedObject.name) + " "), _c('i', [_c('small', [_vm._v(_vm._s(_vm._f("address")(_vm.sharedObject)) + "  ")])])])], 1) : (_vm.sharedObject.kind == "file") ? _c('div', {
    staticClass: "link file",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('click')
      }
    }
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.sharedObject.group
    }
  }), [(_vm.nodeIsImage(_vm.sharedObject)) ? _c('image-thumb', {
    attrs: {
      "src": _vm.downloadLink(_vm.sharedObject, 2)
    }
  }) : _vm._e(), (_vm.nodeIsYoutubeLink(_vm.sharedObject)) ? _c('image-thumb', {
    staticClass: "youtube",
    attrs: {
      "src": _vm.getNodeYoutubeImageLink(_vm.sharedObject)
    }
  }) : _vm._e(), (_vm.nodeIsYoutubeLink(_vm.sharedObject)) ? _c('i', {
    staticClass: "fa fa-youtube-play playOverVideo"
  }) : _vm._e(), (_vm.hasNotPreviewImage(_vm.sharedObject)) ? _c('i', {
    staticClass: "fa",
    class: _vm._f("nodeIconClass")(_vm.sharedObject)
  }) : _vm._e()], _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("ucfirst")(_vm._f("unixtimeTo")(_vm.sharedObject.creationDate, 'llll'))))]), _c('div', {
    staticClass: "address"
  }, [_vm._v(_vm._s(_vm.hrS(_vm.sharedObject.size)))])], 2) : (_vm.sharedObject.kind == "poll") ? _c('div', {
    staticClass: "link poll",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('click')
      }
    }
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.sharedObject.group
    }
  }), _c('i', {
    staticClass: "fa fa-tasks"
  }), _c('div', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm._f("ucfirst")(_vm._f("unixtimeTo")(_vm.sharedObject.startTime, 'llll'))))]), _c('div', {
    staticClass: "date"
  }, [_vm._v("> " + _vm._s(_vm._f("ucfirst")(_vm._f("unixtimeTo")(_vm.sharedObject.endTime, 'llll'))))])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5edbc8fa","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SharedObjectAbstract.vue
// module id = 885
// module chunks = 13